// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"8b26b9ce","186":"083b6afa","344":"b7a6c4ad","372":"3d4894c2","377":"3f0ca946","630":"16085eec","841":"2a40eb32","851":"4c17e2e1","856":"7e0f6964","858":"95ed61e0"}[chunkId] + ".chunk.js";
};